<!--万达电影app-H5-我的权益列表-->
<template>
  <div class="home">
    <img src="./img3.png" alt="">
<!--    <div class="clickBlock area1" style="top:21vh" @click="area1Fun">1</div>-->
    <div class="clickBlock area1" style="top:40vh" @click="area1Fun"></div>
    <div class="clickBlock area1" style="top:52vh" @click="area1Fun"></div>
<!--    <div class="clickBlock area1" style="top:72vh" @click="area1Fun">4</div>-->
    <div class="clickBlock area1" style="top:90vh" @click="area3Fun"></div>
    <div class="clickBlock area2" @click="area2Fun"></div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'Home',
  data(){
    return {
      isMini:false
    }
  },
  components: {
  },
  methods:{
    // 酒店权益
    area1Fun(){
      if(this.isMini){
        wx.miniProgram.navigateTo({url: '/pages/aMini/toMini/toMini'})
        // wx.miniProgram.navigateToMiniprogram({
        //   appId: 'wx57ebde74de5e6267',
        //   envVersion: 'trial'
        // })
      }else {
        this.$bsUtils.nativeApi.jumpPage('wdmp://mp.wanda.cn/launchMiniProgram?username=gh_53441af22e1c')
      }

    },
    // 影城权益
    area3Fun(){
      if(this.isMini){
        wx.miniProgram.navigateTo({url: '/pages/aMini/mv/mv'})
      }else {
        this.$bsUtils.nativeApi.jumpPage('wdmp://mp.wanda.cn/constructionApply')
      }
    },
    area2Fun(){
      this.$router.back(-1)
    }
  },
  mounted() {
    console.log(1111111,   window.webkit)// eslint-disable-line no-console
    try {
      console.log(2222222,   window.webkit.messageHandlers)// eslint-disable-line no-console
    }catch (e){
      console.log('获取messageHandlers失败')// eslint-disable-line no-console
      console.log('error', e)// eslint-disable-line no-console
    }

    if(this.$route.query.src==='mini'){
      this.isMini = true
    }
  }
};
</script>
<style lang="less" scoped>
  .home {
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    position: relative;
    >img {
      position: relative;
      width: 100%;
      height: auto;
      //height: 100%;
    }
    .area1 {
      width: 20vw;
      height: 7vh;
      right: 5vw;
    }
    .area2 {
      width: 12vw;
      height: 12vw;
      top: 5vh;
    }
  }
</style>
